/**
 * Navigation handlers for parts (prev/next)
 */
import { createSelectedContentFromPart } from "../utils/partUtils";

/**
 * Handle previous part navigation
 */
export const createHandlePrevPart = ({
  text,
  allParts,
  currentGlobalIndex,
  setTexts,
  setSelectedText,
}) => {
  return () => {
    if (currentGlobalIndex > 0) {
      const prevPart = allParts[currentGlobalIndex - 1];
      const newSelectedContent = createSelectedContentFromPart(
        prevPart,
        prevPart.typeName
      );

      setTexts((prevTexts) =>
        prevTexts.map((t) =>
          t.id === text.id ? { ...t, selectedContent: newSelectedContent } : t
        )
      );

      setSelectedText((prev) => ({
        ...prev,
        selectedContent: newSelectedContent,
      }));
    }
  };
};

/**
 * Handle next part navigation
 */
export const createHandleNextPart = ({
  text,
  allParts,
  currentGlobalIndex,
  setTexts,
  setSelectedText,
}) => {
  return () => {
    if (currentGlobalIndex < allParts.length - 1) {
      const nextPart = allParts[currentGlobalIndex + 1];
      const newSelectedContent = createSelectedContentFromPart(
        nextPart,
        nextPart.typeName
      );
      newSelectedContent.content = `${nextPart.part.trim()} - Qty-${
        nextPart.qty
      } ${nextPart.unit}`;

      setTexts((prevTexts) =>
        prevTexts.map((t) =>
          t.id === text.id ? { ...t, selectedContent: newSelectedContent } : t
        )
      );

      setSelectedText((prev) => ({
        ...prev,
        selectedContent: newSelectedContent,
      }));
    }
  };
};
